//@flow
import React from "react";
import { connect } from "react-redux";
import classNames from "classnames";

import { FiInfo as IconeHint } from "react-icons/fi";
import {
  Tooltip,
  TooltipArrow,
  TooltipReference,
  useTooltipState,
} from "reakit/Tooltip";

import { Translate } from "@quantum/i18n";
import { NumberField } from "@quantum/ui";

import { isMultiplasMedidasSelecionadas } from "../../../../util";

import {
  type Id,
  MODO_APP_SERIES,
  VALOR_DEFAULT_JANELA_MOVEL_VISIVEL,
  MEDIDAS_COM_DEFAULT_JANELA_MOVEL_4,
  MEDIDAS_COM_TOOLTIP_JANELA_MOVEL,
} from "../../../../model";

import {
  type State,
  type ActionCreator,
  selecionarJanelaMovel,
  getJanelaMovelSelecionada,
  getModoExibicaoMedidaSelecionada,
  getModoExibicaoPorChave,
  getModoApp,
  getIdMedidaSelecionada,
} from "../../../../state";

type Props = {
  exibir: boolean,
  janelaMovelSelecionada: number,
  idMedidaSelecionada: ?Id,
  selecionarJanelaMovel: ActionCreator,
};

const exibirSelecaoJanelaMovel: (state: State) => boolean = (state: State) => {
  const modoExibicaoMedidaSelecionada = getModoExibicaoMedidaSelecionada(state);

  return (
    getModoApp(state) === MODO_APP_SERIES &&
    getModoExibicaoPorChave(state)(
      modoExibicaoMedidaSelecionada &&
        isMultiplasMedidasSelecionadas(modoExibicaoMedidaSelecionada)
        ? ""
        : modoExibicaoMedidaSelecionada !== null
        ? modoExibicaoMedidaSelecionada
        : ""
    ).modoComJanelaMovel
  );
};

function SelecaoJanelaMovel({
  exibir,
  janelaMovelSelecionada,
  idMedidaSelecionada,
  selecionarJanelaMovel,
}: Props) {
  const tooltip = useTooltipState();

  if (!exibir) return null;

  function onBlur() {
    if (janelaMovelSelecionada !== 0 && !janelaMovelSelecionada) {
      selecionarJanelaMovel(
        (idMedidaSelecionada !== null &&
        idMedidaSelecionada !== undefined &&
        MEDIDAS_COM_DEFAULT_JANELA_MOVEL_4.includes(idMedidaSelecionada)
          ? 4
          : VALOR_DEFAULT_JANELA_MOVEL_VISIVEL) ||
          VALOR_DEFAULT_JANELA_MOVEL_VISIVEL
      );
    }
  }

  const exibirTooltip = MEDIDAS_COM_TOOLTIP_JANELA_MOVEL.includes(
    idMedidaSelecionada
  );

  return (
    <>
      <label
        className={classNames("ConfiguracaoMedida__label", {
          "ConfiguracaoMedida__label--hint": exibirTooltip,
        })}
      >
        <Translate>{"configuracaoRelatorio.janelaMovel"}</Translate>
        {exibirTooltip && (
          <>
            <TooltipReference {...tooltip}>
              <IconeHint />
            </TooltipReference>
            <Tooltip {...tooltip} className="ConfiguracaoMedida__tooltip">
              <Translate>configuracaoRelatorio.hintJanelaMovel</Translate>
              <TooltipArrow {...tooltip} />
            </Tooltip>
          </>
        )}
      </label>
      <NumberField
        className="ConfiguracaoMedida__input"
        allowNegative={false}
        max={Number.MAX_SAFE_INTEGER}
        min={1}
        onChangeValue={valor => selecionarJanelaMovel(valor)}
        value={janelaMovelSelecionada}
        onBlur={onBlur}
      />
    </>
  );
}

export default connect(
  (state: State) => ({
    exibir: exibirSelecaoJanelaMovel(state),
    janelaMovelSelecionada: getJanelaMovelSelecionada(state),
    idMedidaSelecionada: getIdMedidaSelecionada(state),
  }),
  { selecionarJanelaMovel }
)(SelecaoJanelaMovel);
